export const HAS_UPCOMING_BILLING_INTERVAL = 'has-upcoming-billing-interval';
export const CURRENT_BILLING_INTERVAL_NOT_PACKAGE = 'current-billing-interval-not-package';
export const NOT_PAYED = 'not-payed';
export const IMPORTANCE_CONFLICT = 'importance-conflict';
export const NO_CARD = 'no-card';
export const OPEN_INVOICES = 'open-invoices';
export const CLIENT_DECLINED = 'client-declined';
export const TERMS_AND_CONDITIONS_NOT_SIGNED = 'terms-and-conditions-not-signed';



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/upgrade-or-downgrade/store/not-allowed-reasons.ts